import { Component } from '@angular/core';
import { ConsentService } from 'src/app/services/consentService/consent.service';
import { DialogService } from 'src/app/services/dialogService/dialog-service';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.less']
})
export class ConsentComponent {
  showConsent: Boolean = false;
  constructor(private consentService: ConsentService, public dialogService: DialogService) {
    this.showConsent = consentService.showConsent();
  }

  /** Accept all cookies */
  confirmAll() {
    this.consentService.acceptAll();
    this.showConsent = false;
  }

  /** Accept only functional cookies */
  confirmFunc() {
    this.consentService.acceptNecessary();
    this.showConsent = false;
  }
}